export default __webpack_public_path__ + "static/media/galin_xl.8136f9c9.jpg";